import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function SwollenLegsHeroSection() {
  return <section className="relative w-full pt-2 pb-12 sm:pt-3 sm:pb-20 md:pb-24 lg:pb-12" style={{
    backgroundColor: '#FFFFFF'
  }} data-id="element-1316">
      {/* Background subtle gradient */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-ginger-light/5 to-transparent pointer-events-none" data-id="element-1317" />

      {/* Decorative blur element */}
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-ginger/5 rounded-full blur-3xl pointer-events-none" data-id="element-1318" />

      <div className="max-w-7xl mx-auto px-6 w-full grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center" data-id="element-1319">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center sm:items-start text-center sm:text-left z-10" data-id="element-1320">
          {/* Trust Bar Pill */}
          <div className="mb-3 sm:mb-4 w-full flex justify-center sm:justify-start" data-id="element-1321">
            <div className="bg-[#D6ECD6] rounded-[20px] py-[14px] px-[14px] sm:py-[18px] sm:px-[20px] inline-flex items-center gap-3 sm:gap-[18px] max-w-[600px]" data-id="element-1322">
              {/* Avatar Stack */}
              <div className="flex items-center flex-shrink-0" data-id="element-1323">
                {['https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=120&h=120&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1557862921-37829c790f19?w=120&h=120&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?w=120&h=120&fit=crop&crop=faces'].map((src, i) => <div key={i} className="w-[48px] h-[48px] sm:w-[62px] sm:h-[62px] rounded-full border-[3px] border-[#D6ECD6] overflow-hidden flex-shrink-0 shadow-md" style={{
                marginLeft: i === 0 ? 0 : '-14px',
                zIndex: 3 - i
              }} data-id="element-1324">
                    <img src={src} alt="" className="w-full h-full object-cover object-top" loading="eager" decoding="async" width="120" height="120" data-id="element-1325" />
                  </div>)}
              </div>

              {/* Right Content */}
              <div className="flex flex-col gap-[5px] sm:gap-[7px] min-w-0" data-id="element-1326">
                {/* Stars: 4 full + 1 at 80% */}
                <div className="flex items-center gap-[3px]" aria-label="4.8 out of 5 stars" data-id="element-1327">
                  {[...Array(4)].map((_, i) => <svg key={i} className="w-[22px] h-[22px] sm:w-[30px] sm:h-[30px]" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1328">
                      <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" fill="#E8720C" data-id="element-1329" />
                    </svg>)}
                  {/* 5th star: 80% filled */}
                  <svg className="w-[22px] h-[22px] sm:w-[30px] sm:h-[30px]" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1330">
                    <defs data-id="element-1331">
                      <clipPath id="trustFill80" data-id="element-1332">
                        <rect x="0" y="0" width="19.2" height="24" data-id="element-1333" />
                      </clipPath>
                    </defs>
                    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" fill="#C8B8A0" data-id="element-1334" />
                    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" fill="#E8720C" clipPath="url(#trustFill80)" data-id="element-1335" />
                  </svg>
                </div>

                {/* Stats Text */}
                <div className="text-[13px] sm:text-[clamp(14px,2.8vw,18px)] text-[#1A1A1A] leading-[1.3] whitespace-nowrap sm:whitespace-nowrap" data-id="element-1336">
                  <strong className="font-extrabold" data-id="element-1337">4.8 stars</strong>
                  <span className="text-[#5A7A5A] mx-1.5 font-normal" data-id="element-1338">|</span>
                  <strong className="font-extrabold" data-id="element-1339">10K+</strong> reviews
                  <span className="text-[#5A7A5A] mx-1.5 font-normal" data-id="element-1340">|</span>
                  <strong className="font-extrabold" data-id="element-1341">10K+</strong> members
                </div>
              </div>
            </div>
          </div>

          <div className="inline-block px-4 py-1.5 mb-4 sm:mb-5 border border-ginger/20 rounded-full bg-white/50 backdrop-blur-sm shadow-sm mx-auto sm:mx-0" data-id="element-1342">
            <span className="text-ginger font-medium text-xs tracking-[0.3em] uppercase" data-id="element-1343">
              America's #1 Ginger Oil
            </span>
          </div>

          {/* Badge */}

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-charcoal leading-[1.1] mb-4 sm:mb-6 tracking-tight" data-id="element-1344">
            By Evening, Your Legs Aren't Tired{' '}
            <span className="text-ginger font-normal block mt-2" data-id="element-1345">
              They're Holding Pressure
            </span>
          </h1>

          <p className="text-sm sm:text-base lg:text-lg text-charcoal-light/90 mb-6 sm:mb-8 leading-relaxed font-light max-w-xl mx-auto sm:mx-0" data-id="element-1346">
            Tight ankles, lingering sock marks, and heavy legs are signs
            circulation has slowed. The right warmth helps your body release
            pressure — not freeze it.
          </p>

          {/* Hero Image - Mobile Only */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.4,
          delay: 0.05,
          ease: 'easeOut'
        }} className="relative w-full mb-6 sm:mb-8 lg:hidden" data-id="element-1347">
            <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl shadow-ginger/10" data-id="element-1348">
              <img src="https://cdn.magicpatterns.com/uploads/wUwAcuA9g9WXr9jdDX3bQj/banner_ginext_60_off_hero.png" alt="GINEXT Ginger Oil - Limited Time 60% Off with circulation benefits" className="w-full h-auto" loading="eager" fetchpriority="high" decoding="async" width="800" height="1000" data-id="element-1349" />
            </div>
          </motion.div>

          {/* CTA Block */}
          <div className="w-full flex flex-col items-center sm:items-start" data-id="element-1350">
            {/* Yellow Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.25
          }} className="relative z-10 mb-[-14px]" data-id="element-1351">
              <span className="inline-block bg-[#F5D24B] text-[#1A1A1A] text-[11px] sm:text-xs font-extrabold uppercase tracking-wider px-4 py-1.5 rounded-full shadow-sm" data-id="element-1352">
                10,000+ Bottles Sold
              </span>
            </motion.div>

            {/* Green CTA Button */}
            <a href="#bundles" className="block scroll-smooth w-full sm:w-auto lg:w-full" data-id="element-1353">
              <motion.div whileHover={{
              scale: 1.02,
              boxShadow: '0 12px 32px -8px rgba(34, 120, 60, 0.4)'
            }} whileTap={{
              scale: 0.98
            }} className="w-full sm:w-auto lg:w-full bg-[#1B6B3A] text-white px-10 sm:px-14 lg:px-16 py-4 sm:py-5 lg:py-6 rounded-full font-black text-lg sm:text-xl lg:text-2xl shadow-xl transition-all duration-300 text-center tracking-tight" data-id="element-1354">
                Save 60% + Free Shipping
              </motion.div>
            </a>

            {/* Risk-Free Line */}
            <div className="mt-3 flex items-center justify-center sm:justify-start gap-2 w-full" data-id="element-1355">
              <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1356">
                <circle cx="10" cy="10" r="10" fill="#4CAF50" data-id="element-1357" />
                <path d="M6 10.5l2.5 2.5L14 8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1358" />
              </svg>
              <span className="text-sm sm:text-base text-charcoal font-medium" data-id="element-1359">
                Try It{' '}
                <span className="underline underline-offset-2 decoration-charcoal" data-id="element-1360">
                  Risk-Free For 30 Days
                </span>
              </span>
            </div>
          </div>

          {/* Trust Stats - Below CTA */}
          <div className="mt-3 sm:mt-4 flex flex-col items-center sm:items-start gap-1" data-id="element-1361">
            <div className="flex items-center gap-[2px]" aria-label="4.8 out of 5 stars" data-id="element-1362">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-ginger text-ginger" data-id="element-1363" />)}
            </div>
            <p className="text-xs sm:text-sm text-charcoal-light" data-id="element-1364">
              <strong className="font-semibold text-charcoal" data-id="element-1365">4.8 stars</strong>
              <span className="mx-1.5 text-charcoal-light/50" data-id="element-1366">|</span>
              <strong className="font-semibold text-charcoal" data-id="element-1367">10K+</strong>{' '}
              reviews
              <span className="mx-1.5 text-charcoal-light/50" data-id="element-1368">|</span>
              <strong className="font-semibold text-charcoal" data-id="element-1369">10K+</strong>{' '}
              members
            </p>
          </div>
        </motion.div>

        {/* Desktop Hero Image */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="hidden lg:block relative" data-id="element-1370">
          <div className="relative w-full overflow-hidden rounded-3xl shadow-2xl shadow-ginger/20" data-id="element-1371">
            <img src="https://cdn.magicpatterns.com/uploads/wUwAcuA9g9WXr9jdDX3bQj/banner_ginext_60_off_hero.png" alt="GINEXT Ginger Oil - Limited Time 60% Off with circulation benefits" className="w-full h-auto" loading="eager" fetchpriority="high" decoding="async" width="800" height="1000" data-id="element-1372" />
          </div>

          {/* Floating accent element */}
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-ginger/10 rounded-full blur-2xl pointer-events-none" data-id="element-1373" />
        </motion.div>
      </div>

      {/* Value Prop Card */}
      <div className="max-w-7xl mx-auto px-6 mt-12 sm:mt-16 lg:hidden" data-id="element-1374">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-[#FDE8D0] rounded-2xl p-7 sm:p-9 max-w-[560px] mx-auto sm:mx-0" data-id="element-1375">
          <h2 className="text-[clamp(28px,6vw,40px)] font-black text-[#1A1A1A] leading-[1.12] mb-7" data-id="element-1376">
            You Have Circulation Gaps.&nbsp;
            <span className="text-ginger" data-id="element-1377">GINEXT Fixes Them.</span>
          </h2>

          <ul className="list-none mb-7 flex flex-col gap-4" data-id="element-1378">
            {['100% Botanical Formula. 4 Clinically-Studied Ingredients.', 'Deep Warming Relief. 3× Faster Than Leading Topical Creams.', 'Third-Party Tested & Dermatologist Reviewed.'].map((item, i) => <li key={i} className="flex items-start gap-3.5 text-[clamp(16px,3.5vw,19px)] text-[#1A1A1A] leading-[1.4]" data-id="element-1379">
                <svg className="shrink-0 w-7 h-7 mt-px" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1380">
                  <circle cx="14" cy="14" r="14" fill="#E8720C" data-id="element-1381" />
                  <path d="M8 14.5l4 4 8-8" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" data-id="element-1382" />
                </svg>
                {item}
              </li>)}
          </ul>

          <p className="text-[clamp(16px,3.5vw,19px)] font-extrabold text-[#1A1A1A] leading-[1.4]" data-id="element-1383">
            No Menthol. No Cold Shock. No Greasy Film. Just Daily Warming
            Relief.
          </p>
        </motion.div>
      </div>
    </section>;
}